import React, { FC, useEffect, useState } from 'react';
import Image from 'next/image';
import Link from 'next/link';
import { MenuAlt1Icon } from '@heroicons/react/outline';
import { motion } from 'framer-motion';
import { useStore } from 'pages/_app';
import { useEffectOnce } from 'react-use';
import { useRouter } from 'next/dist/client/router';
import { BsTelephoneFill } from 'react-icons/bs';
import { IoMdMail } from 'react-icons/io';

interface NavBarProps {
	hideUserDashboardButton?: boolean;
	hideConfigurationButton?: boolean;
}

export const NavBar: FC<NavBarProps> = (props) => {
	const { hideConfigurationButton, hideUserDashboardButton } = props;

	const [showMobile, setShowMobile] = useState(false);
	const router = useRouter();

	const cart = useStore();

	const animationVariants = {
		initial: {
			left: '100%',
			transition: {
				duration: 0.3,
				ease: [0.83, 0, 0.17, 1],
			},
		},
		animate: {
			left: '0px',
			transition: {
				duration: 0.3,
				ease: [0.83, 0, 0.17, 1],
			},
		},
	};

	useEffect(() => {
		// Prevent scrolling
		if (showMobile) document.body.style.overflow = 'hidden';

		return () => {
			// Enable scrolling
			document.body.style.overflow = 'visible';
		};
	}, [showMobile]);

	useEffectOnce(() => {
		const handleRouteChange = (url, { shallow }) => {
			setShowMobile(false);
		};

		router.events.on('routeChangeStart', handleRouteChange);

		return () => {
			router.events.off('routeChangeStart', handleRouteChange);
		};
	});

	return (
		<div className="w-full bg-black fixed top-0 z-50">
			<div className="bg-primary w-full">
				<div className="container mx-auto flex justify-center space-x-6 py-1">
					<a className="text-white underline flex items-center space-x-2" href="tel:0800 007402">
						<BsTelephoneFill className="text-white w-3 h-3" />
						<p>0800 007402</p>
					</a>
					<a
						className="text-white underline flex items-center space-x-2"
						href="mailto:kundenservice@siccro.at"
					>
						<IoMdMail className="text-white w-3 h-3" />
						<p>kundenservice@siccro.at</p>
					</a>
				</div>
			</div>
			<nav className="container flex mx-auto items-center justify-between">
				<div className="flex space-x-12 ml-3">
					<Link href="/">
						<Image
							src="/images/Logo.png"
							height="60px"
							width="120px"
							objectFit="cover"
							className="p-0 cursor-pointer"
							onClick={() => setShowMobile(false)}
						/>
					</Link>
					<div className="space-x-6 h-full py-5 hidden sm:flex">
						<Link href="/kontakt">
							<a className="text-white text-s cursor-pointer hover:text-primary">KONTAKT</a>
						</Link>
						<Link href="/jobs">
							<a className="text-white text-s cursor-pointer hover:text-primary">JOBS</a>
						</Link>
						{/* <Link href="/user/dashboard">
							<a className="text-white text-s cursor-pointer hover:text-primary">KUNDENPORTAL</a>
						</Link> */}
					</div>
				</div>
				<div className="space-x-3 hidden sm:flex">
					<Link href="angebot">
						<a
							className={`text-white text-s border-primary border-2 p-3 rounded-md hover:text-primary ${
								hideUserDashboardButton ? 'invisible' : 'visible'
							}`}
						>
							ANGEBOT EINHOLEN
						</a>
					</Link>
					{/* <Link href="/config/category">
						<a
							className={`text-white text-s bg-primary p-3 rounded-md ${
								hideConfigurationButton ? 'invisible' : 'visible'
							}`}
							onClick={() => cart.resetConfiguration()}
						>
							KONFIGURATOR
						</a>
					</Link> */}
				</div>
				<MenuAlt1Icon
					className="text-white w-8 h-8 mr-3 hover:text-primary block sm:hidden"
					onClick={() => setShowMobile(!showMobile)}
				/>
			</nav>
			<motion.div
				initial={animationVariants.initial}
				animate={showMobile ? animationVariants.animate : animationVariants.initial}
				exit={animationVariants.initial}
				className="absolute w-screen z-50 top-20 bg-black flex"
				style={{ height: 'calc(calc(var(--vh, 1vh) * 100) - 3.5rem)' }}
			>
				<div
					className="py-5 flex flex-col w-full p-6 space-y-3 justify-between pb-20"
					style={{ height: 'calc(100% - 3.5rem)' }}
				>
					{/* <Link href="/config/category">
						<a
							className={`text-white text-lg text-center bg-primary p-3 rounded-md ${
								hideConfigurationButton ? 'invisible' : 'visible'
							}`}
							onClick={() => setShowMobile(false)}
						>
							Preisrechner
						</a>
					</Link> */}
					<div className="flex flex-col space-y-6">
						<Link href="/kontakt">
							<a className="text-white w-full text-xl cursor-pointer hover:text-primary">Kontakt</a>
						</Link>
						<Link href="/angebot">
							<a className="text-white w-full text-xl cursor-pointer hover:text-primary">
								Angebot einholen
							</a>
						</Link>
						{/* <Link href="/jobs">
							<a className="text-white w-full text-xl cursor-pointer hover:text-primary">Jobs</a>
						</Link> */}
					</div>
					<Link href="/user/dashboard">
						<a
							className={`text-white text-lg text-center border-primary border-2 p-3 rounded-md hover:text-primary ${
								hideUserDashboardButton ? 'invisible' : 'visible'
							}`}
							onClick={() => setShowMobile(false)}
						>
							Kundenportal
						</a>
					</Link>
				</div>
			</motion.div>
		</div>
	);
};
